import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import MaterialsEnergyWater41_1aTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const MaterialsEnergyWater41_1a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("INDIRECT_EMISSIONS") || "Indirect emissions"}
        subDescription={t("INDIRECT_EMISSIONS_41_1A_DESC") || "Fill in information about the use of your product here. Provide an estimate of the average usage of the product."}
        isNormal={true}
        number={"41.1a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`materials-energy-water-41-1a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <MaterialsEnergyWater41_1aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default MaterialsEnergyWater41_1a;


